import type { ContractRecord } from '@libs/data-access/entities'
import type { ShiftRecord } from '@libs/data-access/queries'
import { useCommonAppTranslation } from '@libs/utils/translations'
import { membershipsSelectors } from '@spa/scenes/Plannings/redux/selectors'

type Props = {
  contract: ContractRecord
  shift: ShiftRecord
}

/**
 * @deprecated please don't use it
 */
const useGetDefaultUserContractLegacy = ({
  contract,
  shift
}: Props): { label?: string; value: number; highlight?: string } => {
  const { t } = useCommonAppTranslation()
  const membership = membershipsSelectors.useGetCachedById(
    contract?.membership_id
  )

  if (!contract || !shift) {
    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    return null
  }
  return {
    label: t('models.fullname', {
      value: {
        firstname: membership?.firstname,
        lastname: membership?.lastname
      }
    }),
    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    value: shift.user_contract_id
  }
}

export default useGetDefaultUserContractLegacy
